import type { Component } from "vue";
import BorradorOperacionEnergiaDatos from "@/components/borradores-operacion/energia/BorradorOperacionEnergiaDatos.vue";
import BorradorOperacionAguaDatos from "@/components/borradores-operacion/agua/BorradorOperacionAguaDatos.vue";

const datosComponents = {
  ENERGIA: BorradorOperacionEnergiaDatos,
  AGUA: BorradorOperacionAguaDatos,
} as const;

export function getBorradorOperacionDatosComponent(tipo?: string): Component {
  const key = (tipo ?? "").toUpperCase() as keyof typeof datosComponents;
  return datosComponents[key] ?? BorradorOperacionEnergiaDatos;
}